import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { CaseServiceReason } from '../../cases/_types/case-service-reason';
import { CasesServicesReasonsService } from '../../cases/_services/cases-services-reasons.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-cases-services-reasons-detail',
    templateUrl: './cases-services-reasons-detail.component.html',
    styleUrls: ['./cases-services-reasons-detail.component.scss'],
    standalone: false
})
export class CasesServicesReasonsDetailComponent {
  public caseServiceReasonFormGroup!: RxFormGroup;

  public caseServiceReason: CaseServiceReason = new CaseServiceReason();
  //public caseServiceReasonTypes: any[] = [];

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private casesServicesReasonsService: CasesServicesReasonsService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
        private config: DynamicDialogConfig,
        private dynamicDialogRef: DynamicDialogRef,
  ) {

    this.caseServiceReasonFormGroup = this.formBuilder.formGroup<CaseServiceReason>(this.caseServiceReason) as RxFormGroup;
  }

  async ngOnInit() {
    let id =this.config.data.Id; // this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadCaseServiceReason(id);
    }else{
      this.caseServiceReasonFormGroup.patchValue({caseServiceCauseId: this.config.data.caseServiceCauseId, caseServiceReasonType: this.config.data.caseServiceReasonType});
    }
    this.allowWrite = true; //this.loginService.hasPermission("CASES_TYPES.WRITE");
    this.allowDelete = true; //this.loginService.hasPermission("CASES_TYPES.DELETE");
  }

  async loadCaseServiceReason(id: string) {
    this.caseServiceReason = await firstValueFrom(this.casesServicesReasonsService.get(id));
    this.caseServiceReasonFormGroup.patchValue(this.caseServiceReason);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.caseServiceReasonFormGroup);
    if (valid) {
      this.caseServiceReason = Object.assign(this.caseServiceReason, this.caseServiceReasonFormGroup.value);
      let caseServiceReason = await firstValueFrom(this.casesServicesReasonsService.save(this.caseServiceReason));
      this.messageService.add({ closable: true, severity: 'success', summary: "Motivo guardado correctamente." });
      //this.router.navigate(['casesServicesReasons']);
      this.dynamicDialogRef.close(caseServiceReason);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el motivo?",
      header: "Eliminar motivo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.casesServicesReasonsService.delete(this.caseServiceReason.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Motivo eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    //this.router.navigate(['casesServicesReasons']);
    this.dynamicDialogRef.close();
  }

}
